import React, { FC, useMemo } from "react";

import { ICustomField } from "@/data/custom-fields";
import { Flex } from "@/eworkitComponents";
import { CustomField } from "@/views/components/CustomFields/CustomField";

export interface ICustomFieldsProps {
  customFields?: ICustomField[];
}

export const CustomFields: FC<ICustomFieldsProps> = ({ customFields = [], children }) => {
  const sortedCustomFields = useMemo(
    () => customFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    [customFields],
  );

  return (
    <Flex direction="column" innerMargin>
      {sortedCustomFields.map(customField => (
        <CustomField key={customField.name} customField={customField} />
      ))}

      {children}
    </Flex>
  );
};
